import {
  AlibabaForm,
  getAlibabaFreightTemplates,
  alibabaDetail,
  alibabaDetailEdit,
  alibabaDetailEdit2,
  alibabaCategoryProps,
  alibabaBatchUpdateCategory,
  getAlibabaTemplateList,
  getAlibabaShippingAddress,
  alibabaDetailSupplier,
  getAlibabaItemPublishSubSchema,
  alibabaGetShippingAddress,
  getAlibabaAsyncQueryInfo
} from '@/api/prod/center'
import store from '@/store'

/**
 * 获取动态表单
 * @param {*} params 
 * @returns 
 */
export function getForm(params) {
  return AlibabaForm(params).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  }).catch(err => {
    return false
  })
}
/**
 * 获取次级属性数据
 * @param {*} params 
 * @returns 
 */

export function getItemPublishSchemaPropV2(params) {
  return getAlibabaItemPublishSubSchema(params).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  }).catch(err => {
    return false
  })
}

export function getFreightTemplateList(params) {
  return getAlibabaFreightTemplates(params).then(res => {
    if (res.result === 1) {
      return res?.data?.freightTemplates || []
    } else {
      return []
    }
  }).catch(err => {
    return []
  })
}

// 远程搜索下拉选项
export function queryOptions(params) {
  return getAlibabaAsyncQueryInfo(params).then(res => {
    if (res.result === 1) {
      return res.data ? JSON.parse(res.data)?.data?.dataSource || [] : []
    } else {
      return []
    }
  }).catch(err => {
    return []
  })
}



// 过滤上传失败或为空的图片
export function _filterInvalidImg(imgsArr) {
  return imgsArr.filter(img => {
    if (!img) {
      return false
    } else if (typeof img === 'object') {
      return false
    } else {
      return true
    }
  })
}

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
  if (r.skuList && r.skuList.length > 0) {
    r.skuList = r.skuList.map(item => {
      return isRequest ? {
        ...item,
        skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : []),
        industrySkuSpecifications: JSON.stringify(item.industrySkuSpecifications ? item.industrySkuSpecifications : [])
      } : {
        ...item,
        skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : [],
        industrySkuSpecifications: item.industrySkuSpecifications ? JSON.parse(item.industrySkuSpecifications) : []
      }
    })
  }

  return isRequest ? {
    ...r,
    specificationNames: JSON.stringify(r.specificationNames ? r.specificationNames : []),
    specifications: JSON.stringify(r.specifications ? r.specifications : []),
    categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
    itemOfficialLogistics: JSON.stringify(r.itemOfficialLogistics ? r.itemOfficialLogistics : {}),
  } : {
    ...r,
    specificationNames: r.specificationNames ? JSON.parse(r.specificationNames) : [],
    specifications: r.specifications ? JSON.parse(r.specifications) : [],
    categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
    templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : [],
    sendAddressConfig: r.sendAddressConfig ? JSON.parse(r.sendAddressConfig) : [],
    itemOfficialLogistics: r.itemOfficialLogistics ? JSON.parse(r.itemOfficialLogistics) : {},
  }
}

// 编辑详情
export function editAlibabaDetail(data) {
  if (data.preSale === 1) {
    data.theDayOfDeliverGoodsTime = -1
  } else if (data.preSale === 2) {
    data.promiseDeliveryTime = -1
  }
  return alibabaDetailEdit(_formatGoodsItem(data, true)).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}
// 编辑详情
export function editAlibabaDetail2(data,expandParams) {
  if (data.preSale === 1) {
    data.theDayOfDeliverGoodsTime = -1
  } else if (data.preSale === 2) {
    data.promiseDeliveryTime = -1
  }
  let params = _formatGoodsItem(data, true)
  params = {
    itemInfo:{...params},
    ...expandParams
  }
  return alibabaDetailEdit2(params).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

// 获取详情资料
export function getAlibabaDetail(baseItemId) {
  return alibabaDetail({
    baseItemId
  }).then(res => {
    if (res.result === 1) {
      // debugger;
      return _formatGoodsItem(res.data)
    } else {
      return false
    }
  })
}
// 获取详情资料(供销商小店版)
export function getAlibabaDetailSupplier(params) {
  return alibabaDetailSupplier(params).then(res => {
    if (res.result === 1) {
      // debugger;
      return _formatGoodsItem(res.data)
    } else {
      return false
    }
  })
}

// 查询类目属性
export function getCategoryProps(data) {
  let _shopId = store.getters.shops_getCategoryPropShopId('alibaba') || 33413
  let _data = {
    ...data,
    shopId: data.shopId ? data.shopId : _shopId, // 默认店铺
    webSite: '1688'
  }
  return alibabaCategoryProps(_data).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}


// 批量修改类目
export function batchAlibabaCategory(data) {
  return alibabaBatchUpdateCategory(data).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

// 获取发货地址内容
export function batchAlibabaShippingAddress(data) {
  return alibabaGetShippingAddress(data).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}